module.exports = __webpack_public_path__ + "img/potion_9.75abee83.png";